export default __webpack_public_path__ + "static/media/hummingbird-printed-t-shirt (1).24b3c6f9.jpg";